export const NavigationOrigins = {
    NONE: "NONE",
    DETAIL_FROM_DETAIL: "DETAIL_FROM_DETAIL",
    ROAD_FROM_DETAIL: "ROAD_FROM_DETAIL",
    ROAD_FROM_BACK_DETAIL: "ROAD_FROM_BACK_DETAIL",
    ROAD_FROM_ROAD: "ROAD_FROM_ROAD",
    ROAD_FROM_NETWORK: "ROAD_FROM_NETWORK",
    ROAD_FROM_SEARCH: "ROAD_FROM_SEARCH",
}
